import { Component, EventEmitter, Output } from '@angular/core';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { YesNoPipe } from '../../../pipes/yes-no.pipe';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-cancel-booking-overlay',
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatSnackBarModule,
        YesNoPipe
    ],
    templateUrl: './cancel-booking-overlay.component.html',
    styleUrl: './cancel-booking-overlay.component.scss'
})
export class CancelBookingOverlayComponent {
    @Output("onClose") onClose= new  EventEmitter<boolean>()
    @Output("onConfirm") onConfirm= new  EventEmitter<boolean>()

    constructor(
        private snackBar: MatSnackBar,
    ) {

    }

    close() {
        // this.authService.closeDeleteOverlay()
        this.onClose.emit(true)
    }

    confirm() {
        // this.authService.executeDeleteProfile()
        this.onConfirm.emit(true)
    }
}
